// Config
const API_URL = process.env.GATSBY_API_URL || "/.netlify/functions"

const BASE_API_URL = `${API_URL}`

export const FOLLOW_ENDPOINT = `${BASE_API_URL}/follow-us`
